import styled from 'styled-components';

export const PainelSec = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 5rem 4%;
  background: #eef7fd;

  @media screen and (max-width: 414px) {
    padding: 3rem 4%;
  }
`;

export const PainelContainer = styled.div`
  margin: auto;
  display: grid;
  max-width: 1210px;
  justify-content: center;
  grid-gap: 10px;
  align-items: center;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  @media screen and (max-width: 899px) {
    grid-template-columns: minmax(230px, 1fr);
  }
`;

export const PainelCardGraph = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const PainelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;




export const ExceptionText = styled.p`
  font-weight: 500;
  width: 100%;
  color: #909090;
  margin: auto;
  text-align: center;
  padding: 0 2rem;
`;
